import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
export default {
	bootstrapMaterial:
		'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDs+5yTVZf+TzyiBFk7Y0mTZTkgTRi7uqzbLB4w1mGC8TMHRtKW9KXzAlsBoyv2SoddcQ8cCLPy7GF11G+lCxbAwOP9X4mbZISqsgCm7ybGFghtttcOw9tNnTsVP03FEHDSmCkvepGbgnHkGjrW4ZjAmlMtIulqCGipCXpg8KCuHQIDAQAB',
	enabled: !!configJson.decoderCfg.enabled,
	pwdKeys: configJson.decoderCfg.pwdKeys || '',
	devMode: configJson.decoderCfg.devMode || false,
	sessionToken: null,
	allocSessionToken() {
		if (!!!this.sessionToken) {
			let library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
			let key = ''
			for (let i = 0; i < 16; i++) {
				let randomPoz = Math.floor(Math.random() * library.length)
				key += library.substring(randomPoz, randomPoz + 1)
			}
			this.sessionToken = key
		}
		return this.sessionToken
	},
	encodeBlock(word, keyStr) {
		keyStr = keyStr || this.allocSessionToken()
		let key = CryptoJS.enc.Utf8.parse(keyStr)
		let srcs = CryptoJS.enc.Utf8.parse(word)
		let encrypted = CryptoJS.AES.encrypt(srcs, key, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		})
		return encrypted.toString()
	},
	decodeBlock(word, keyStr) {
		keyStr = keyStr ? keyStr : this.allocSessionToken()
		let key = CryptoJS.enc.Utf8.parse(keyStr)
		let decrypt = CryptoJS.AES.decrypt(word, key, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7
		})
		return CryptoJS.enc.Utf8.stringify(decrypt).toString()
	},
	encodeHandshake(data, material) {
		material = material || this.bootstrapMaterial
		let encryptor = new JSEncrypt()
		encryptor.setPublicKey(material)
		return encryptor.encrypt(data)
	},
	applyOutbound(request) {
		if (!this.enabled) {
			return request
		}
		let body = request.params || {}
		if (this.devMode) {
			console.log('请求:', request.url, body)
		}
		let paramStr = ''
		for (let key in body) {
			let value = body[key]
			if (!!value && this.pwdKeys.indexOf(key) > -1) {
				value = this.encodeHandshake(value)
			}
			paramStr += key + '=' + value + '&'
		}
		if (request.method == 'get') {
			request.params = { encrypt: this.encodeBlock(paramStr) }
		} else {
			request.data = { encrypt: this.encodeBlock(paramStr) }
			request.params = {}
		}
		return request
	},
	applyInbound(response) {
		if (!this.enabled) {
			return response
		}
		let body = response.data || {}
		if (!!body.encrypt) {
			body = JSON.parse(this.decodeBlock(body.encrypt))
		}
		if (this.devMode) {
			console.log('响应:', response.config.url, body)
		}
		response.data = body
		return response
	}
}



// WEBPACK FOOTER //
// ./src/utils/decoder.js